export default {"src":"/_next/static/media/37.bc0337a8.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};